import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: any = null;

  constructor(private http: HttpClient) { }

  // Uygulama başlamadan önce bu fonksiyon tetiklenecek
  loadConfig(): Promise<any> {
    return this.http.get('./assets/config.json')
      .toPromise() // Angular 7 için Promise dönüşümü
      .then(data => {
        this.config = data;
      })
      .catch(err => {
        console.error('Config dosyası yüklenemedi, varsayılan değer atanıyor.', err);
        this.config = { apiUrl: 'http://localhost:5110/' }; // Fallback
      });
  }

  // API URL'ini almak için kullanılacak metot
  get apiUrl(): string {
    return this.config ? this.config.apiUrl : 'http://localhost:5110/';
  }
}
